import * as React from 'react';
import {
    Create,
    ReferenceInput,
    AutocompleteInput,
    TextInput,
    SimpleForm,
    BooleanInput,
    required,
    useTranslate,
} from 'react-admin';
import { Typography } from '@mui/material';
import { RichTextInput } from '../../components/RichTextInput';

const req = [required()];

const EntityCreate = () => {
    const translate = useTranslate();

    return (
        <>
            {/* @ts-ignore */}
            <Create>
                <SimpleForm sx={{ maxWidth: { xl: '80%' } }}>
                    <TextInput
                        source="title"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput source="slug" fullWidth />
                    <BooleanInput source="active" fullWidth />
                    <TextInput
                        source="annotation"
                        fullWidth
                        multiline
                        maxRows={'10'}
                    />
                    <RichTextInput source="content" fullWidth />
                    <ReferenceInput source="city_id" reference="cities">
                        <AutocompleteInput optionText="title" fullWidth />
                    </ReferenceInput>
                    <BooleanInput source="is_all_cities" fullWidth />
                    <TextInput source="icon" fullWidth />
                    <Typography variant="h6" gutterBottom>
                        {translate('resources.pages.fieldGroups.seo')}
                    </Typography>
                    <TextInput source="seo_h1" fullWidth />
                    <TextInput
                        source="seo_description"
                        fullWidth
                        multiline
                        maxRows={'10'}
                    />
                    <BooleanInput source="seo_no_index" fullWidth />
                    <TextInput source="seo_canonical" fullWidth />
                </SimpleForm>
            </Create>
        </>
    );
};

export default EntityCreate;
